import { Menu, Music, X } from 'lucide-react';
import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function MarketingNav() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const handleBookDemo = () => {
    if (location.pathname === '/') {
      document.getElementById('hero-form')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/#hero-form');
    }
  };
  return (
    <header className="fixed top-0 left-0 right-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-lg">
      <div className="container mx-auto flex h-14 sm:h-16 items-center justify-between px-4">
        <Link to="/" className="flex items-center gap-2 sm:gap-3">
          <div className="flex h-8 w-8 sm:h-9 sm:w-9 items-center justify-center rounded-lg bg-gradient-to-br from-primary to-primary/80">
            <Music className="h-4 w-4 sm:h-5 sm:w-5 text-primary-foreground" />
          </div>
          <div className="flex flex-col">
            <span className="font-display text-lg sm:text-xl font-bold leading-tight">
              Venue<span className="text-primary">Intel</span>
            </span>
            <span className="text-[10px] text-muted-foreground/70 leading-none hidden sm:block">
              The operating system for modern venues
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <Link
            to="/our-story"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Our Story
          </Link>
          <Link
            to="/blog/hidden-cost-disconnected-venue-technology"
            className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
          >
            Research
          </Link>
        </nav>

        <div className="hidden sm:flex items-center gap-3">
          <Button variant="outline" size="sm" onClick={handleBookDemo}>
            Book a Demo
          </Button>
          <Button size="sm" asChild>
            <Link to="/design-partners">Become a Founding Partner</Link>
          </Button>
        </div>

        <button
          className="sm:hidden flex items-center justify-center h-9 w-9 rounded-md hover:bg-muted transition-colors"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {open && (
        <div className="sm:hidden border-t border-border/50 bg-background/95 backdrop-blur-lg px-4 pb-5 pt-3 space-y-3">
          <Link
            to="/our-story"
            onClick={() => setOpen(false)}
            className="block text-sm font-medium text-muted-foreground hover:text-foreground py-2"
          >
            Our Story
          </Link>
          <Link
            to="/blog/hidden-cost-disconnected-venue-technology"
            onClick={() => setOpen(false)}
            className="block text-sm font-medium text-muted-foreground hover:text-foreground py-2"
          >
            Research
          </Link>
          <div className="pt-2 space-y-2">
            <Button
              variant="outline"
              size="sm"
              className="w-full"
              onClick={() => {
                setOpen(false);
                handleBookDemo();
              }}
            >
              Book a Demo
            </Button>
            <Button size="sm" asChild className="w-full">
              <Link to="/design-partners" onClick={() => setOpen(false)}>
                Become a Founding Partner
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
}
